import { effect, Injectable, signal } from '@angular/core';
import { UserInfo } from './user';
import { klona as clone } from 'klona';

import { SessionStorage } from 'ngx-webstorage';
import { LoginInfo } from '../auth/auth';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    // #region Injects

    // #endregion

    // #region Properties

    @SessionStorage() _userSession!: UserInfo | null;
    protected readonly _user = signal<UserInfo | null>(null);
    get user() {
        return this._user.asReadonly();
    }

    // #endregion

    constructor() {
        // If we have session storage for a user, then we can restore the _user signal from this.
        if (!!this._userSession) this._user.set(this._userSession);

        // Effect to ensure that when the _user signal updates, we update the session storage as well.
        effect(() => {
            const user = this._user();

            this._userSession = user;
        });
    }

    // #region Clear User

    clearUser() {
        this._user.set(null);
    }

    // #endregion

    // #region Set User

    setUser(loginInfo: LoginInfo) {
        const entry = {
            AuthToken: loginInfo.AuthToken,
            Email: loginInfo.Email,
            FirstName: loginInfo.FirstName,
            LastName: loginInfo.LastName,
            UserID: loginInfo.UserID,
            Roles: loginInfo.Roles,
        } as UserInfo;

        // Store in signal.
        this._user.set(entry);
    }

    // #endregion

    // #region Update AuthToken Service Call

    updateAuthToken(authToken: string): void {
        const user = this._user();

        // If the authtoken has changed, update the user record.
        if (authToken !== user?.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our
            // existing User object.
            const newUser: UserInfo = clone(user) as UserInfo;

            // Update the AuthToken field
            newUser.AuthToken = authToken;

            // Now, store in signal, which will cause it to persist to session storage and then broadcast it for listeners
            this._user.set(newUser);
        }
    }

    // #endregion
}
